const FLEET_SIZE_BOOST_EFFECT_ID = 50397286;

const createSingleLevelSkillBuff = ({
  itemGid,
  name,
  description,
  effects,
}) => ({
  itemGid,
  name,
  category: "commanderAndBreakthroughSkills",
  categoryLabel: "Commander & Breakthrough Skills",
  description,
  durationOptions: [{
    level: 0,
    durationSeconds: 0,
    durationLabel: "Activated",
    quality: 4,
    effects,
  }],
  effects,
});

const createLevelSkillBuff = ({
  itemGid,
  name,
  description,
  effectId,
  effectValues,
}) => {
  const durationOptions = (Array.isArray(effectValues) ? effectValues : [])
    .map((value, index) => ({
      level: index,
      durationSeconds: 0,
      durationLabel: `Level ${index + 1}`,
      quality: 4,
      effects: [{ effectId, value }],
    }));
  return {
    itemGid,
    name,
    category: "commanderAndBreakthroughSkills",
    categoryLabel: "Commander & Breakthrough Skills",
    description,
    durationOptions,
    effects: durationOptions[0]?.effects || [],
  };
};

const lowBreakthroughValues = [
  30, 40, 50, 60, 70, 80, 90, 100, 110, 125, 140, 155, 170, 185, 200, 215, 230, 245,
];

const highBreakthroughValues = [
  50, 60, 70, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320, 340, 360,
];

export const COMMANDER_SKILL_BUFF_CATALOG = [
  createSingleLevelSkillBuff({
    itemGid: 83886364,
    name: "Commander Skill: Fast Expansion",
    description: "Manually activated commander skill: Fleet Size Boost +10%.",
    effects: [{ effectId: FLEET_SIZE_BOOST_EFFECT_ID, value: 100 }],
  }),
  createLevelSkillBuff({
    itemGid: 100859981,
    name: "Aeon Breakthrough: Magnetic Shield",
    description: "Manually activated breakthrough skill: melee troops receive a temporary HP-based shield.",
    effectId: 50397348,
    effectValues: highBreakthroughValues,
  }),
  createLevelSkillBuff({
    itemGid: 100859987,
    name: "Alexandria Breakthrough: Rescue",
    description: "Manually activated breakthrough skill: converts some killed attacking troops to wounded until hospital capacity is full.",
    effectId: 50397345,
    effectValues: highBreakthroughValues,
  }),
  createLevelSkillBuff({
    itemGid: 100859983,
    name: "Panda Jack Breakthrough: Exterminate",
    description: "Manually activated breakthrough skill: kills a portion of wounded enemies during the first solo attack.",
    effectId: 50397346,
    effectValues: lowBreakthroughValues,
  }),
  createLevelSkillBuff({
    itemGid: 100859985,
    name: "Storm Bow Breakthrough: Rampart Smasher",
    description: "Manually activated breakthrough skill: increases damage taken by the target City's troops.",
    effectId: 50397344,
    effectValues: lowBreakthroughValues,
  }),
  createLevelSkillBuff({
    itemGid: 100859977,
    name: "Kingsley Breakthrough: Gas Bomb",
    description: "Manually activated breakthrough skill: reduces damage dealt by the target City's troops.",
    effectId: 50397343,
    effectValues: lowBreakthroughValues,
  }),
];

export default COMMANDER_SKILL_BUFF_CATALOG;
